import { z } from "zod";

export const creditsBalanceResponseSchema = z.object({
  balance: z.object({
    account: z.number().int(),
    limit: z.number().int(),
  }),
  creditsPricePerSecond: z.number().int(),
  renewsCreditsAt: z.string().optional(),
  creditsRefreshConfig: z
    .object({
      refreshType: z.enum(["weekly", "monthly", "yearly"]),
      refreshAmount: z.number(),
    })
    .optional(),
});

export const creditActionSchema = z.object({
  actionTimestamp: z.string(),
  userName: z.string(),
  actionDescription: z.string(),
  credits: z.number(),
});

export type BalanceResponseType = z.infer<typeof creditsBalanceResponseSchema>;
export type BalanceType = BalanceResponseType["balance"];
export type CreditActionType = z.infer<typeof creditActionSchema>;
